import 'd3-format'
import * as d3 from 'd3'

const getRounded = (value) => {
  return d3.format('.4~s')(value)
}

export const getRoundedValue = (value) => {
  // For exactly 2 decimal places with SI suffix
  const si = d3.formatPrefix('.2f', value)
  return si(value)
}

export default getRounded

/* Gives rounded value eg: 1.2345e+6 to 1.2345M
 * @param {number} value
 * @returns {string}
 */
